import { useContext, type ReactElement } from 'react';
import { ClientSearchCard } from '../Components/ClientSearchCard';
import { ButtonCard } from '../Components/ButtonCard';
import { Legend } from '@/components/Calendar/Legend/Legend';
import { PlanningContainer } from '../Components/PlanningContainer';
import { openReportsModal } from '../Modals/ReportsModal';
import {
  type PlanningContextType,
  StateContext,
} from '@/layouts/Planning/PlanningLayout';

export const PlansPage = (): ReactElement => {
  const { planId, service } = useContext<PlanningContextType>(StateContext);

  return (
    <PlanningContainer planState = 'FINISHED'>
      <ClientSearchCard planState = 'FINISHED'/>
      <ButtonCard
        header="Hromadné akce"
        buttons={[
          {
            label: 'PDF Plány',
            onClick: () => openReportsModal(planId, service, 'PLAN'),
          },
        ]}
      />
      <Legend
        label="Legenda"
        colors={[
          {
            label: 'Nepřiřazené',
            color: '#A0A0A0',
          },
          {
            label: 'Přiřazené',
            color: '#0000F0',
          },
        ]}
      />
    </PlanningContainer>
  );
};
